import React from 'react';
import ok from 'assets/img/ico-ok.png';
export const DossierValidated = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'text-center my-5' },
            React.createElement("img", { src: ok, alt: 'ok' }),
            React.createElement("h1", { className: 'font-size-20 text-black fw-600 mt-5' }, "Votre enqu\u00EAte est maintenant termin\u00E9e"),
            React.createElement("p", { className: 'font-size-14 text-black mb-0' }, "Vous pouvez quitter la page quand vous le souhaitez."),
            React.createElement("p", { className: 'font-size-14 text-black mb-0' }, "Nous vous souhaitons une bonne journ\u00E9e."))));
};
